import 'core-js/modules/es.object.assign.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Text, Button } from '@hub-la/design-system';
import { Stack } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { ResponsiveModal } from './responsive-modal/index.js';

const ConfirmDeleteModal = props => {
  const {
    isOpen,
    isDeleting,
    collaboratorName,
    onClose,
    onConfirm
  } = props;
  const {
    t
  } = useTranslation();
  return jsx(ResponsiveModal, Object.assign({
    open: isOpen,
    onClose: onClose
  }, {
    children: jsxs(Stack, Object.assign({
      flexDirection: "column",
      spacing: 6,
      "data-testid": "confirm-delete-rule-modal-content"
    }, {
      children: [jsx(Stack, Object.assign({
        flexDirection: "row"
      }, {
        children: jsx(Text, Object.assign({
          variant: "h3"
        }, {
          children: t('deleteCollaboratorModal.title', {
            collaboratorName
          })
        }))
      })), jsx(Stack, Object.assign({
        flexDirection: "row"
      }, {
        children: jsx(Text, Object.assign({
          variant: "body1"
        }, {
          children: t('deleteCollaboratorModal.description')
        }))
      })), jsxs(Stack, Object.assign({
        flexDirection: "row",
        justifyContent: "end",
        gap: 2
      }, {
        children: [jsx(Button, Object.assign({
          variant: "outlined",
          onClick: onClose,
          disabled: isDeleting
        }, {
          children: t('deleteCollaboratorModal.buttons.cancel')
        })), jsx(Button, Object.assign({
          variant: "filled",
          size: "medium",
          onClick: onConfirm,
          loading: isDeleting
        }, {
          children: t('deleteCollaboratorModal.buttons.confirm')
        }))]
      }))]
    }))
  }));
};

export { ConfirmDeleteModal };
